import styled from '@emotion/styled';

export const CardToolbarLead = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
  min-width: 0;
`;
